import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import CardDetail from './CardDetail';

const LayoutCards = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 16px 0px;
  overflow-y: auto;
  height: 425px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d6d6d6;
    height: 20px;
    border-radius: 10px;
  }
`;

const Layout = styled.div`
  padding: 8px;
`;

const TransactionsDetailModalMobile = ({ handleCloseError, headerData }) => (
  <>
    <Layout>
      <Header data={headerData} />
      <LayoutCards>
        <CardDetail handleCloseError={handleCloseError} data={headerData} />
      </LayoutCards>
    </Layout>
  </>
);

export default TransactionsDetailModalMobile;
